import React from 'react';
import randomstring from 'uuid/v4';

import { findItem } from '../../../../functions/forms';

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

class Action extends React.Component {
    state = {
        action: undefined
    };

    static getDerivedStateFromProps(props, state) {
        const { action } = props;
        console.log(action);
        if (action !== state.action) {
            state.action = action;
            return state;
        }
        return null;
    }

    isOk = () => {
        const { action } = this.state;
        return action.tipo &&
                ((action.tipo === 1 && action.parametros && action.parametros.campo) ||
                 (action.tipo === 2 && action.parametros && action.parametros.tipo && (action.parametros.plantilla || (action.parametros.familia && action.parametros.proceso))))
            ;
    }

    render() {
        const { action } = this.state;
        const { intl, templates, index, families } = this.props;
        const family = action.tipo !== 1 && action.parametros && action.parametros.tipo === "1" ? families.map((f) => f.codigo).indexOf(action.parametros.familia) : undefined;
        const processes = family >= 0 ? families[family].processes : [];
        const background =  this.isOk() ? 'bg_cloudy_blue' : 'bg_ligth_lipstick_20';

        const campo = action && action.parametros && action.parametros.campo ? findItem(this.props.manage_form.tabs, action.parametros.campo.codigo) : undefined;
        return (
                <Card className={'product_card cardRemoved ' + background}>
                    <CardContent>
                        <Grid container justify="center" className={'flex_grow_1'}>
                            <Grid item xs={3} className="">
                                    <div className="barlow_regular_small c_slate_grey margin_right_18 text_align_right ">
                                        {action.tipo !== 1 && intl.formatMessage({
                                                             id: 'checks_then_title',
                                                        })}
                                        {action.tipo === 1 && intl.formatMessage({
                                                            id: 'checks_then_title_show',
                                                        })}
                                    </div>
                            </Grid>
                            <Grid item xs={9} className="">
                                <div className="flex_full_column">
                                    {action.tipo === 1 && action.parametros && action.parametros.campo && (
                                        <div className={'flex_full_row align_center padding_bottom_12 shadow_down_only'}>
                                            <div className={'display_flex heigth100 width64px center'}>
                                                {this.props.getIcon(action.parametros.campo.tipo,action.parametros.campo.estilo)}
                                            </div>
                                            <div className={'flex_full_row barlow_regular_textwrap c_slate text_align_left text_wrap upper'}
                                                 dangerouslySetInnerHTML={{
                                                    __html: campo.nombre.toUpperCase(),
                                                }}
                                            />
                                        </div>
                                    )}
                                    {action.tipo !== 1 && 
                                        <div className="flex_full_row margin_bottom_12">
                                            <FormControl required className={ 'flex_full width100 barlow_italic c_slate'}>
                                                <InputLabel htmlFor="age-native-simple">
                                                    {intl.formatMessage({ id: 'checks_then_placeholder' })}
                                                </InputLabel>
                                                <Select
                                                    native
                                                    value={action.parametros.tipo}
                                                    onChange={(event) => this.props.handleChangeAction('parametros',index,event.target.value,'tipo')}
                                                    inputProps={{ name: 'tipo', id: 'tipo-simple' }}
                                                >
                                                    <option key={randomstring()} value={undefined}  />
                                                    <option key={randomstring()} value={1} >
                                                        {intl.formatMessage({ id: 'checks_launch_process' })}
                                                    </option>
                                                    <option key={randomstring()} value={2}>
                                                        {intl.formatMessage({ id: 'checks_send_mail' })}
                                                    </option>
                                                </Select>
                                            </FormControl>
                                        </div>
                                    }
                                    {action.tipo !== 1 && action.parametros && action.parametros.tipo === "2" &&
                                         <div className="flex_full_row margin_bottom_12 margin_top_8">
                                            <FormControl required className={'flex_full width100 barlow_italic c_slate'}>
                                                <InputLabel htmlFor="age-native-simple">
                                                    {intl.formatMessage({ id: 'template' })}
                                                </InputLabel>
                                                <Select
                                                    native
                                                    value={action.parametros.plantilla}
                                                    onChange={(event) => this.props.handleChangeAction( 'parametros', index, event.target.value, 'plantilla')}
                                                    inputProps={{ name: 'plantilla', id: 'plantilla-simple'}}
                                                >
                                                    <option key={randomstring()} value={undefined}/>
                                                    {templates &&
                                                            templates.length > 0 &&
                                                                templates
                                                                    .sort((a,b) => a.nombre > b.nombre ? 1 : -1)
                                                                    .map((i) =>
                                                                        <option key={randomstring()} value={i.id} >
                                                                            {i.nombre}
                                                                        </option>
                                                                    )
                                                    }
                                                </Select>
                                            </FormControl>
                                        </div>
                                    }
                                    {action.tipo !== 1 && action.parametros && action.parametros.tipo === "1" &&
                                        <React.Fragment>
                                            <div className="flex_full_row align_center">
                                                <FormControl className={'flex_full width100 barlow_italic c_slate'}>
                                                    <InputLabel htmlFor="age-native-simple" >
                                                        {intl.formatMessage({ id: 'family' })}
                                                    </InputLabel>
                                                    <Select
                                                        native
                                                        value={action.parametros.familia}
                                                        onChange={(event) => this.props.handleChangeAction( 'parametros', index, event.target.value, 'familia')}
                                                        inputProps={{ name: 'family', id: 'family-id' }}
                                                        className="upper"
                                                    >
                                                        <option key={randomstring()} value={undefined} />
                                                        {families &&
                                                            families
                                                                .sort((a, b) => (a.nombre < b.nombre ? -1 : 1))
                                                                .map((f) => <option 
                                                                                key={randomstring()}
                                                                                className="upper"
                                                                                value={f.codigo}
                                                                            >
                                                                                {f.nombre.toUpperCase()}
                                                                            </option>
                                                                )}
                                                    </Select>
                                                </FormControl>
                                            </div>
                                            <div className="flex_full_row align_center margin_top_18">
                                                <FormControl className={'flex_full width100 barlow_italic c_slate'}>
                                                    <InputLabel htmlFor="age-native-simple">
                                                        {intl.formatMessage({ id: 'process' })}
                                                    </InputLabel>
                                                    <Select
                                                        native
                                                        value={action.parametros.proceso}
                                                        onChange={(event) => this.props.handleChangeAction( 'parametros', index, event.target.value, 'proceso')}
                                                        inputProps={{ name: 'process', id: 'process-id' }}
                                                        className="upper"
                                                    >
                                                        <option key={randomstring()} value={undefined} />
                                                        {processes &&
                                                            processes
                                                                .sort((a, b) => (a.nombre < b.nombre ? -1 : 1))
                                                                .map((f) => 
                                                                        <option
                                                                            key={randomstring()}
                                                                            className="upper"
                                                                            value={f.codigo}
                                                                        >
                                                                            {f.nombre.toUpperCase()}
                                                                        </option>
                                                                )}
                                                    </Select>
                                                </FormControl>
                                            </div>
                                        </React.Fragment>
                                    }
                                </div>
                            </Grid>
                        </Grid>
                    </CardContent>
            </Card>
        )
    }
}

export default Action;


// WEBPACK FOOTER //
// ./src/components/complex/manage/checks/Action.js